import { wrapFontFamily } from 'common/components/entities/Text/utils'
import PropTypes from 'prop-types'
import PreviewBanner from 'publisher/components/core/PreviewBanner'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React from 'react'
import Meta from '../components/core/Meta'
import { OnExitPopup } from './components/on-exit-popup'
import { OnloadPopups } from './components/onload-popups'
import { TriggeredPopup } from './components/triggered-popup'
import PageUi from './ui/PageUi'

function CommonPage({ children, noIndex }) {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  return (
    <PageUi
      $textFontFamily={wrapFontFamily(globalTextFontProperties.fontFamily)}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      <Meta noIndex={noIndex} />
      <PreviewBanner />
      {children}
      <TriggeredPopup />
      <OnExitPopup />
      <OnloadPopups />
    </PageUi>
  )
}

CommonPage.propTypes = {
  children: PropTypes.node.isRequired,
  noIndex: PropTypes.bool,
}

CommonPage.propTypes = {
  noIndex: false,
}

export default CommonPage
